import { useLoading } from '../contextos/LoadingContext';
import { Backdrop, CircularProgress } from '@mui/material';

export default function GlobalSpinner() {
  const { loading } = useLoading();

  return (
    <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
